import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import {
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import EmptyContent from "components/EmptyContent";
import List from "components/UI/List";
import { Feature } from "models/api";
import React, { useState } from "react";
import Search from "components/Search/Search";
import useFetchSection from "hooks/useFetchSection";
import { getNotifications, NotificationsCells, readNotifications } from "framework/notifications";
import { INotification } from "models/notifications";
import { Check, RemoveRedEye } from "@mui/icons-material";
import { useMutation } from "react-query";
import { useAlert } from "contexts/alertContext";
import { handleError } from "helpers/utils";


interface Props {
  feature: Feature;
}

const Notifications: React.FC<Props> = ({ feature }) => {
  const [loading2, setLoading2] = useState<boolean>(false);
  const [FilterNotifications, setFilterNotifications] = useState<INotification[]>([] as INotification[]);
  const { setAlert } = useAlert();

  const checkNotificationMutation = useMutation({
    mutationFn: (id: string) => {
      return readNotifications(id);
    },
  });

  const {
    loading,
    data: Notifications,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getNotifications(),
    fetchPermission: async () => null,
    onSuccess: (data) => setFilterNotifications(data),
    section: "Notifications",


  });

  if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );



  const getBodyCells = (row: INotification) => {
    let cells = Object.keys(row).map((key: string, i: number) => {

      if (key === "clientName")
        return {
          id: "clientName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.clientName}</Typography>
            </TableCell>
          ),
        };

      if (key === "notificationDate")
        return {
          id: "notificationDate",
          element: (
            <TableCell align="left" key={i}>
              <Typography variant="body2">
                {new Date(row?.notificationDate).toLocaleDateString()}
              </Typography>
            </TableCell>
          ),
        };

      if (key === "countryCode")
        return {
          id: "countryCode",
          element: (
            <TableCell align="left" key={i}>
              <Typography variant="body2">
                {row?.countryCode}
              </Typography>
            </TableCell>
          ),
        };

      if (key === "phoneNumber")
        return {
          id: "phoneNumber",
          element: (
            <TableCell align="left" key={i}>
              <Typography variant="body2">
                {row?.phoneNumber}
              </Typography>
            </TableCell>
          ),
        };


      if (key === "message")
        return {
          id: "message",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.message}</Typography>
            </TableCell>
          ),
        };


      if (key === "clientId")
        return {
          id: "id",
          element: (
            <TableCell align={"left"} key={i}>
              <Tooltip title={"Mark as read"}>
                <IconButton
                  size={"small"}
                  color={"primary"}
                  onClick={() => handleRead(row.id.toString())}
                >
                  <Check />
                </IconButton>
              </Tooltip>
            </TableCell>
          ),
        };





    });
    return cells;
  };



  const handleSearch = async (value: string) => {
    if (!value) return setFilterNotifications(Notifications!);
    let filtered = Notifications!.filter((service) =>
      service.clientName.toLowerCase().includes(value.toLowerCase()) || service.message.toLowerCase().includes(value.toLowerCase()) || service.countryCode.toLowerCase().includes(value.toLowerCase()) || service.phoneNumber.toLowerCase().includes(value.toLowerCase()) || service.notificationDate.toLowerCase().includes(value.toLowerCase())
    );
    setFilterNotifications(filtered);
  };



  const handleRead = async (id: string) => {
    try {
      setLoading2(true);
      await checkNotificationMutation.mutateAsync(`/${id}`);
      setAlert({
        open: true,
        message: "Notification Read",
        type: "success",
      });
      revalidate();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  return (
    <>
      <Stack spacing={2} p={2}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          sx={{ mb: 4 }}
        >
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Typography
              variant="h3"
              color={"header.primary"}
            >
              {(feature.name)}
            </Typography>



          </Stack>
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Stack
              direction={{ lg: "row", xs: "column" }}
              spacing={1}
              width={"100%"}
            >
              <Search handleChange={handleSearch} placeholder={"Search"} />

            </Stack>
          </Stack>
        </Grid>

        {FilterNotifications!.length > 0 && (
          <List
            headCells={NotificationsCells}
            data={FilterNotifications!}
            getBodyCells={getBodyCells}
            feature={feature}
            canEdit={false}
          />
        )}
        {(!FilterNotifications || FilterNotifications.length === 0) &&

          <EmptyContent
            icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
            header={"No Notifications"}
            message={"No Notifications Exists Yet"}
          />
        }


      </Stack>

    </>
  );
};

export default Notifications;
